/* landing-cover.js — rotate the homepage cover story, and fill the issue bar.
 *
 * The hero renders server-side (newest featured creator story) and stays correct
 * with JS off. This adds prev/next controls that swap its contents from the pool
 * in landing-covers.hbs.
 *
 * Video reuses the theme's existing manifest lookup, window.tdcVideoUrl(basename),
 * keyed on the feature image's filename — the same resolution the static hero
 * uses. A cover with no clip simply shows its still, which is most of them.
 *
 * Idempotent: this theme re-runs init (see default.hbs).
 */
(function () {
  'use strict';

  // ── subscribe band → Ghost Portal ──
  // Ghost's members.js isn't loaded on this site (only portal.min.js), so a
  // data-members-form would native-submit and reload the page as if it had
  // worked. Hand off to Portal, which every other subscribe control uses.
  var subForm = document.getElementById('subbandForm');
  if (subForm && subForm.dataset.wired !== '1') {
    subForm.dataset.wired = '1';
    subForm.addEventListener('submit', function (e) {
      e.preventDefault();
      window.location.hash = '#/portal/signup';
    });
  }

  var pool = document.getElementById('coverPool');
  var hero = document.querySelector('.zine-hero-feature');
  if (!pool || !hero) return;
  if (hero.dataset.rotator === '1') return;
  hero.dataset.rotator = '1';

  var items = [].slice.call(pool.querySelectorAll('.cover-item'));

  // ── issue bar counts, derived from the records on the page ──
  var stats = document.getElementById('issueStats');
  if (stats) {
    var recs = document.querySelectorAll('.rec').length;
    var tools = {};
    document.querySelectorAll('.rec').forEach(function (r) {
      (r.getAttribute('data-tax') || '').split('|').forEach(function (t) {
        if (t.indexOf('#tool:') === 0) tools[t.slice(6)] = 1;
      });
    });
    var nTools = Object.keys(tools).length;
    if (recs) {
      stats.textContent = recs + ' creators taken apart' + (nTools ? '  ·  ' + nTools + ' tools documented' : '');
    }
  }

  if (items.length < 2) return;

  var media = hero.querySelector('.hero-media-container');
  var video = hero.querySelector('.hero-video');
  var fallback = hero.querySelector('.hero-image-fallback');
  var titleA = hero.querySelector('.zine-hero-title a');
  var catEl = hero.querySelector('.zine-hero-category');
  var excerpt = hero.querySelector('.zine-hero-excerpt');
  var metaInfo = hero.querySelector('.meta-info');
  var readBtn = hero.querySelector('.read-button');
  if (!titleA || !excerpt) return;

  // The server-rendered hero is items[0] (both are featured-first, newest-first).
  var idx = 0;

  // ── controls ──
  var nav = document.createElement('div');
  nav.className = 'cover-nav';
  nav.innerHTML =
    '<button type="button" class="cover-btn" data-dir="-1" aria-label="Previous cover story">‹</button>' +
    '<span class="cover-count" aria-live="polite"></span>' +
    '<button type="button" class="cover-btn" data-dir="1" aria-label="Next cover story">›</button>';
  hero.appendChild(nav);
  var countEl = nav.querySelector('.cover-count');

  function basename(path) {
    return (path || '').split('/').pop().split('?')[0].replace(/\.[^/.]+$/, '');
  }

  function paint(i) {
    var it = items[i];
    var img = it.getAttribute('data-img');
    var url = it.getAttribute('data-url');

    titleA.textContent = it.querySelector('[data-f="title"]').textContent;
    titleA.setAttribute('href', url);
    if (readBtn) readBtn.setAttribute('href', url);
    excerpt.textContent = it.querySelector('[data-f="excerpt"]').textContent;
    if (catEl) catEl.textContent = it.getAttribute('data-cat') || '';
    if (metaInfo) {
      var rt = it.getAttribute('data-rt');
      metaInfo.textContent = it.getAttribute('data-date') + (rt ? ' • ' + rt : '');
    }

    // Still first, then upgrade to video only if the manifest has one — same
    // order the static hero uses, so a slow connection degrades to an image.
    // The still is an <img> with a srcset; swap both so the browser keeps
    // choosing the right size for the screen.
    if (fallback && img) {
      var set = it.getAttribute('data-srcset');
      if (set) fallback.setAttribute('srcset', set); else fallback.removeAttribute('srcset');
      fallback.setAttribute('src', img);
    }
    if (media && img) media.setAttribute('data-image-url', img);
    if (video) {
      video.pause();
      video.classList.remove('loaded');
      video.removeAttribute('src');
      video.load();
      if (typeof window.tdcVideoUrl === 'function') {
        var key = basename(it.getAttribute('data-file'));
        window.tdcVideoUrl(key).then(function (src) {
          // Guard against a slow lookup landing after the user moved on.
          if (!src || items[idx] !== it) return;
          video.src = src;
          video.load();
          var p = video.play();
          if (p) p.then(function () { video.classList.add('loaded'); }).catch(function () {});
        }).catch(function () {});
      }
    }
    countEl.textContent = (i + 1) + ' / ' + items.length;
  }

  function go(step) {
    idx = (idx + step + items.length) % items.length;
    hero.classList.add('cover-swapping');
    setTimeout(function () {
      paint(idx);
      requestAnimationFrame(function () { hero.classList.remove('cover-swapping'); });
    }, 260);
  }

  nav.addEventListener('click', function (e) {
    var b = e.target.closest('.cover-btn');
    if (b) go(parseInt(b.getAttribute('data-dir'), 10));
  });

  document.addEventListener('keydown', function (e) {
    if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
    if (e.key === 'ArrowLeft') go(-1);
    if (e.key === 'ArrowRight') go(1);
  });

  countEl.textContent = '1 / ' + items.length;
})();
